import Vue from 'vue'
import Router from 'vue-router'
import { BASE_ROUTER } from "./config";
import { store } from './store/store';

import LoginComponent from './components/auth/LoginComponent';
import ProfileComponent from './components/shared/profile/ProfileComponent';

//sections
import AdminComponent from './components/admin/AdminComponent';
import ClientComponent from './components/client/ClientComponent';
import AgentComponent from './components/agent/AgentComponent';
import FtnComponent from './components/fnt/FtnComponent';

//Configuration
import ConfigComponent from './components/admin/config/ConfigComponent';
import StatusOrderComponent from './components/admin/config/statuses/orders/StatusOrderComponent';
import StatusSampleComponent from './components/admin/config/statuses/samples/StatusSampleComponent';
import PrioritySampleComponent from './components/admin/config/priorities/samples/PrioritySampleComponent';
import ApplicationSampleComponent from './components/admin/config/applications/samples/ApplicationSampleComponent';
import ProjectSampleComponent from './components/admin/config/projects/samples/ProjectSampleComponent';
import AdminsComponent from './components/admin/config/admins/AdminsComponent';

//Sample orders Admin
import AdminSampleComponent from './components/admin/samples/SampleComponent';
import AdminSampleListComponent from './components/admin/samples/ListComponent';
import AdminSampleCreateComponent from './components/admin/samples/CreateComponent';
import AdminSampleDetailComponent from './components/admin/samples/DetailComponent';
import AdminSampleImportCreatedComponent from './components/admin/samples/ImportComponent';
import AdminOrderLinesListComponent from './components/admin/samples/OrderListComponent';

//Sample orders client
import ClientSampleOrderComponent from './components/client/samples/SampleOrderComponent';
import ClientSampleOrderListComponent from './components/client/samples/ListComponent';

//Sample orders agent
import AgentSampleOrderComponent from './components/agent/samples/SampleOrderComponent';
import AgentSampleOrderListComponent from './components/agent/samples/ListComponent';
import AgentSampleOrderDetailComponent from './components/agent/samples/DetailComponent';

//Sample orders FTN
import FtnSampleOrderComponent from './components/fnt/samples/SampleOrderComponent';
import FtnSampleOrderListComponent from './components/fnt/samples/ListComponent';
import FtnSampleOrderDetailComponent from './components/fnt/samples/DetailComponent';

//Clients Admin
import AdminClientComponent from './components/admin/clients/ClientComponent';
import AdminClientListComponent from './components/admin/clients/ListComponent';
import AdminClientCreateComponent from './components/admin/clients/CreateComponent';
import AdminClientDetailComonent from './components/admin/clients/DetailComponent';

//Admin amcs
import AdminAmcComponent from './components/admin/amcs/AmcComponent';
import AdminAmcListComponent from './components/admin/amcs/ListComponent';
import AdminAmcCreateComponent from './components/admin/amcs/CreateComponent';
import AdminAmcDetailComponent from './components/admin/amcs/DetailComponet';

//Orders client
import ClientOrderComponent from './components/client/orders/OrderComponent';
import ClientOrderListComponent from './components/client/orders/ListComponent';
import ClientOrderDetailComponent from './components/client/orders/DetailComponent';

//Orders Agents
import AgentOrderComponent from './components/agent/orders/OrderComponent';
import AgentOrderListComponent from './components/agent/orders/ListComponent';
import AgentOrderDetailComponent from './components/agent/orders/DetailComponent';

//Agents
import AdminAgentComponent from './components/admin/agents/AgentComponent';
import AdminAgentsListComponent from './components/admin/agents/ListComponent';
import AdminAgentsDetailComponent from './components/admin/agents/DetailComponent';
import AdminAgentsCreateComponent from './components/admin/agents/CreateComponent';

//Orders
import AdminOrderComponent from './components/admin/orders/OrderComponent';
import AdminOrdersCreateComponent from './components/admin/orders/CreateComponent';
import AdminOrderListComponent from './components/admin/orders/ListComponent';
import AdminOrdersDetailComponent from './components/admin/orders/DetailComponent';
import AdminOrdersImportCreatedComponent from './components/admin/orders/ImportComponent';

//Ofertas
import OfertaComponent from './components/oferta/OfertaComponent';
import OfertaIndexComponent from './components/oferta/IndexComponent';

//Notifications
import NotificationsComponent from './components/admin/config/notifications/NotificationsComponent';
import NotificationsIndexComponent from './components/admin/config/notifications/IndexComponent';
import NotificationsEditComponent from './components/admin/config/notifications/EditComponent';

//Reset password
import ResetPasswordComponent from './components/shared/reset_password/ResetPasswordComponent';
import SendResetPasswordComponent from './components/shared/reset_password/SendResetPasswordComponent';

//Imports
import ImportClientsComponent from './components/imports/ClientsComponent';

//Home
import AdminHomeComponent from './components/admin/home/HomeComponent';
import AgentHomeComponent from './components/agent/home/HomeComponent';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: BASE_ROUTER,
    //base: '/',
  routes: [
      { path: '/', component: LoginComponent, name : 'login' },
      { path: '/profile', component: ProfileComponent, name : 'profile' },
      { path: '/reset-password/:token', component: ResetPasswordComponent, name : 'reset-password', props: true },
      { path: '/reset-password/send', component: SendResetPasswordComponent, name : 'send-reset-password' },
      { path: '/import/clients', component: ImportClientsComponent, name : 'import-clients' },
      {
          path : '/admin',
          component : AdminComponent,
          beforeEnter: (to, from, next) => {
              if (to.query && to.query.token) {
                  store.dispatch('checkToken', {
                      token: to.query.token
                  }).then((res) => {
                      if (res.data.rol == 'Admin') {
                          next();
                      } else {
                          next('/');
                      }

                  }).catch((error) => {
                      next('/');
                  });
              } else {
                  store.dispatch('checkAccessToken').then((res) => {
                      if (res.data.rol == 'Admin') {
                          next();
                      } else {
                          next('/');
                      }

                  }).catch((error) => {
                      next('/');
                  });
              }
          },
          children : [
              { path : '/', component : AdminHomeComponent, name : 'admin.home' },
              {
                  path : 'amcs',
                  component : AdminAmcComponent,
                  children : [
                      { path : '', component : AdminAmcListComponent, name : 'admin.amcs.list' },
                      { path : 'create', component : AdminAmcCreateComponent, name : 'admin.amcs.create' },
                      { path : ':id', component : AdminAmcDetailComponent, name : 'admin.amcs.detail', props: true }
                  ]
              },
              {
                  path : 'clients',
                  component : AdminClientComponent,
                  children : [
                      { path : '', component : AdminClientListComponent, name : 'admin.clients.list' },
                      { path : 'create', component : AdminClientCreateComponent, name : 'admin.clients.create' },
                      { path : ':id', component : AdminClientDetailComonent, name : 'admin.clients.detail', props: true }
                  ]
              },
              {
                  path : 'agents',
                  component : AdminAgentComponent,
                  children : [
                      { path : '', component : AdminAgentsListComponent, name : 'admin.agents.list' },
                      { path : 'create', component : AdminAgentsCreateComponent, name : 'admin.agents.create' },
                      { path : ':id', component : AdminAgentsDetailComponent, name : 'admin.agents.detail', props: true }
                  ]
              },
              {
                  path : 'orders',
                  component : AdminOrderComponent,
                  children : [
                      { path : '', component : AdminOrderListComponent, name : 'admin.orders.list' },
                      { path : 'create', component : AdminOrdersCreateComponent, name : 'admin.orders.create' },
                      { path : 'import', component : AdminOrdersImportCreatedComponent, name : 'admin.orders.import' },
                      { path : ':id', component : AdminOrdersDetailComponent, name : 'admin.orders.detail', props: true }
                  ]
              },
              {
                  path : 'samples',
                  component : AdminSampleComponent,
                  children : [
                      { path : '', component : AdminSampleListComponent, name : 'admin.samples.list' },
                      { path : 'orders', component : AdminOrderLinesListComponent, name : 'admin.samples.list.orders' },
                      { path : 'create', component : AdminSampleCreateComponent, name : 'admin.samples.create' },
                      { path : 'import', component : AdminSampleImportCreatedComponent, name : 'admin.samples.import' },
                      { path : ':id', component : AdminSampleDetailComponent, name : 'admin.samples.detail', props: true }
                  ]
              },
              {
                  path : 'configurations',
                  component : ConfigComponent,
                  children : [
                      { path : 'status/orders', component : StatusOrderComponent, name : 'admin.config.status.order' },
                      { path : 'status/samples', component : StatusSampleComponent, name : 'admin.config.status.sample' },
                      { path : 'priorities/samples', component : PrioritySampleComponent, name : 'admin.config.priority.sample' },
                      { path : 'applications/samples', component : ApplicationSampleComponent, name : 'admin.config.application.sample' },
                      { path : 'type-projects/samples', component : ProjectSampleComponent, name : 'admin.config.project.sample' },
                      { path : 'admins', component : AdminsComponent, name : 'admin.config.admins' },
                      {
                          path : 'notifications',
                          component : NotificationsComponent,
                          children : [
                              { path : '', component : NotificationsIndexComponent, name : 'admin.notifications.list' },
                              { path : ':id', component : NotificationsEditComponent, name : 'admin.notifications.edit', props: true }
                          ]
                      },
                  ]
              },
          ]
      },
      {
          path : '/c',
          component : ClientComponent,
          beforeEnter: (to, from, next) => {
              if (to.query && to.query.token) {
                  store.dispatch('checkToken', {
                      token: to.query.token
                  }).then((res) => {
                      if (res.data.rol == 'Client') {
                          next();
                      } else {
                          next('/');
                      }

                  }).catch((error) => {
                      next('/');
                  });
              } else {
                  store.dispatch('checkAccessToken').then((res) => {
                      if (res.data.rol == 'Client') {
                          next();
                      } else {
                          next('/');
                      }

                  }).catch((error) => {
                      next('/');
                  });
              }
          },
          children : [
              {
                  path : 'orders',
                  component : ClientOrderComponent,
                  children : [
                      { path : '', component : ClientOrderListComponent, name : 'client.orders.list' },
                      { path : ':id', component : ClientOrderDetailComponent, name : 'client.orders.detail', props: true },
                  ]
              },
              {
                  path : 'samples',
                  component : ClientSampleOrderComponent,
                  children : [
                      { path : '', component : ClientSampleOrderListComponent, name : 'client.sample-orders.list' },
                  ]
              },
          ]
      },
      {
          path : '/a',
          component : AgentComponent,
          name: 'agent',
          beforeEnter: (to, from, next) => {
              if (to.query && to.query.token) {
                  store.dispatch('checkToken', {
                      token: to.query.token
                  }).then((res) => {
                      if (res.data.rol == 'Agent') {
                          next();
                      } else {
                          next('/');
                      }

                  }).catch((error) => {
                      next('/');
                  });
              } else {
                  store.dispatch('checkAccessToken').then((res) => {
                      if (res.data.rol == 'Agent') {
                          next();
                      } else {
                          next('/');
                      }

                  }).catch((error) => {
                      next('/');
                  });
              }
          },
          children : [
              { path : '/', component : AgentHomeComponent, name : 'agent.home' },
              {
                  path : 'orders',
                  component : AgentOrderComponent,
                  beforeEnter: (to, from, next) => {
                      var permisos = store.getters.getPermisos
                      if (permisos.includes('Orders')){
                          next();
                      } else {
                          next('/');
                      }
                  },
                  children : [
                      { path : '', component : AgentOrderListComponent, name : 'agent.orders.list' },
                      { path : ':id', component : AgentOrderDetailComponent, name : 'agent.orders.detail', props: true },
                  ]
              },
              {
                  path : 'samples',
                  component : AgentSampleOrderComponent,
                  beforeEnter: (to, from, next) => {
                      var permisos = store.getters.getPermisos
                      if (permisos.includes('Sample Orders')){
                          next();
                      } else {
                          next('/');
                      }
                  },
                  children : [
                      { path : '', component : AgentSampleOrderListComponent, name : 'agent.sample-orders.list' },
                      { path : ':id', component : AgentSampleOrderDetailComponent, name : 'agent.sample-orders.detail', props: true },
                  ]
              },
          ]
      },
      {
          path : '/f',
          component : FtnComponent,
          beforeEnter: (to, from, next) => {
              if (to.query && to.query.token) {
                  store.dispatch('checkToken', {
                      token: to.query.token
                  }).then((res) => {
                      if (res.data.rol == 'AMC') {
                          next();
                      } else {
                          next('/');
                      }

                  }).catch((error) => {
                      next('/');
                  });
              } else {
                  store.dispatch('checkAccessToken').then((res) => {
                      if (res.data.rol == 'AMC') {
                          next();
                      } else {
                          next('/');
                      }

                  }).catch((error) => {
                      next('/');
                  });
              }
          },
          children : [
              {
                  path : 'samples',
                  component : FtnSampleOrderComponent,
                  children : [
                      { path : '', component : FtnSampleOrderListComponent, name : 'ftn.sample-orders.list' },
                      { path : ':id', component : FtnSampleOrderDetailComponent, name : 'ftn.sample-orders.detail', props: true },
                  ]
              }
          ]
      },
      {
          path : '/offers',
          component : OfertaComponent,
          beforeEnter: (to, from, next) => {
              if (to.query && to.query.token) {
                  store.dispatch('checkToken', {
                      token: to.query.token
                  }).then((res) => {
                      if (res.data.rol == 'Admin') {
                          next();
                      } else {
                          next('/');
                      }

                  }).catch((error) => {
                      next('/');
                  });
              } else {
                  store.dispatch('checkAccessToken').then((res) => {
                      if (res.data.rol == 'Admin') {
                          next();
                      } else {
                          next('/');
                      }

                  }).catch((error) => {
                      next('/');
                  });
              }
          },
          children : [
                { path : '', component : OfertaIndexComponent, name : 'offers.list' },
          ]
      },
  ]
})





// WEBPACK FOOTER //
// ./src/router.js